import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendPromotionCodeInfo,
  BackendQueryPromotionCodeInfoArgs,
} from 'src/types/backend';

const QUERY = gql`
  query PromotionCodeInfo(
    $code: String!
    $plan: String!
    $wordsTier: String
    $billingCycle: String!
    $customerId: ID
  ) {
    promotionCodeInfo(
      code: $code
      plan: $plan
      wordsTier: $wordsTier
      billingCycle: $billingCycle
      customerId: $customerId
    ) {
      durationInMonths
      percentOff
      validTiers
      validPlans
      bonusCredits
      minimumPrice
    }
  }
`;

type Variables = BackendQueryPromotionCodeInfoArgs;
type Result = Pick<
  BackendPromotionCodeInfo,
  'durationInMonths' | 'percentOff' | 'validTiers' | 'validPlans' | 'bonusCredits' | 'minimumPrice'
>;

export const queryPromotionCodeInfo = async (variables: Variables) => {
  const { data, errors } = await executeGqlQuery({ query: QUERY, variables });
  return { data: getSingleProp<Result>(data), error: errors?.[0] };
};
